import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

export default class DoubleSlider {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    this.staircaseTitle()

    const slides = this.el.querySelectorAll('.double-slider--big-slider .swiper-slide').length
    const loop = slides > 1
    const speed = 800

    // Texte : pas de loop car le nombre de textes peut différer du nombre d'images
    const textEl = this.el.querySelector('.double-slider--text-slider')
    const textCount = textEl ? textEl.querySelectorAll('.swiper-slide').length : 0
    this.text = textEl ? new Swiper(textEl, {
      slidesPerView: 1,
      loop: false,
      speed,
      allowTouchMove: false,
    }) : null

    // Petite image : décalée d'un slide (+1)
    this.small = new Swiper(this.el.querySelector('.double-slider--small-slider'), {
      slidesPerView: 1,
      initialSlide: loop ? 1 : 0,
      loop,
      speed,
      allowTouchMove: false,
    })

    // Grande image : pilote la navigation
    this.big = new Swiper(this.el.querySelector('.double-slider--big-slider'), {
      modules: [Navigation, Autoplay],
      slidesPerView: 1,
      loop,
      speed,
      allowTouchMove: false,
      autoplay: {
        delay: 9000,
        disableOnInteraction: false,
      },
      navigation: {
        prevEl: this.el.querySelector('.swiper-button-prev'),
        nextEl: this.el.querySelector('.swiper-button-next'),
      },
    })

    // Texte synchronisé avec modulo : supporte un nombre de textes différent du nombre d'images
    const hasBtns = this.el.classList.contains('double-slider--has-btns')
    if (this.text && !hasBtns && textCount > 0) {
      this.big.on('slideChange', () => {
        this.text.slideTo(this.big.realIndex % textCount, speed, false)
      })
    }

    // Petite image synchronisée avec décalage +1
    this.big.on('slideNextTransitionStart', () => this.small.slideNext())
    this.big.on('slidePrevTransitionStart', () => this.small.slidePrev())

    this.responsiveText()
  }

  // mobile : les <br> du textarea tombent mal sur largeur étroite → remplacés par une espace
  responsiveText() {
    const slider = this.el.querySelector('.double-slider--text-slider')
    if (!slider) return

    const mq = window.matchMedia('(max-width: 991px)')

    const apply = () => {
      slider.querySelectorAll('.double-slider--text').forEach(t => {
        if (t.dataset.html === undefined) t.dataset.html = t.innerHTML
        t.innerHTML = mq.matches ? t.dataset.html.replace(/<br\s*\/?>/gi, ' ') : t.dataset.html
      })
    }

    apply()
    mq.addEventListener('change', apply)
  }

  // décale la première ligne du titre en escalier, mirroré en mode --side
  staircaseTitle() {
    const title = this.el.querySelector('.double-slider--title')
    if (!title) return

    const prop = this.el.classList.contains('double-slider--side') ? 'margin-right' : 'margin-left'

    const parts = title.innerHTML.split(/<br\s*\/?>|\r?\n/i).filter(part => part.trim() !== '')
    title.innerHTML = parts
      .map((part, i) => `<span style="${prop}:${i === 0 ? '2.083vw' : '0'}">${part}</span>`)
      .join('<br>')
  }
}
